/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { userSchema } from './user-schema';

export const usersSavedCandidateSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  userId: z.string().uuid().nullish(),
});

export type UsersSavedCandidate = z.infer<typeof usersSavedCandidateSchema>;
